import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { StoreModule } from '@ngrx/store';
import { BrowserModule } from '@angular/platform-browser';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ConstsHelper } from './helpers/consts.helper';
import { NgxStripeModule } from 'ngx-stripe';

import { AppRoutingModule } from './app-routing.module';
// Environment

import { environment } from '../environments/environment';
// Modules
import { AuthenticationModule } from './modules/authentication/authentication.module';
import { PaymentsModule } from './modules/payments/payments.module';
import { LinesModule } from './modules/lines/lines.module';
import { BillsModule } from './modules/bills/bills.module';
import { AccountModule } from './modules/account/account.module';
import { DimeloModule } from './modules/dimelo/dimelo.module';
import { LandlinesModule } from './modules/landlines/landlines.module';
import { SponsorshipModule } from './modules/sponsorship/sponsorship.module';
import { SubscriptionModule } from './modules/subscription/subscription.module';
import { SharedModule } from './modules/shared/shared.module';
// Components
import { AppComponent } from './app.component';
import { CustomerAreaContainerComponent } from './containers/customer-area-container/customer-area-container.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { FinalizeAccountModule } from './modules/finalize-account/finalize-account.module';
import { DeviceDetectorService } from 'ngx-device-detector';
export const reducers = {};
export const metaReducers = [];
@NgModule({
    declarations: [
        AppComponent,
        CustomerAreaContainerComponent
    ],
    imports: [
        BrowserModule,
        FormsModule,
        NgxStripeModule.forRoot(),
        ReactiveFormsModule,
        HttpClientModule,
        AuthenticationModule,
        SubscriptionModule,
        SharedModule,
        PaymentsModule,
        LinesModule,
        LandlinesModule,
        SponsorshipModule,
        BillsModule,
        DimeloModule,
        AccountModule,
        FinalizeAccountModule,
        StoreModule.forRoot([]),
        !environment.production ? StoreDevtoolsModule.instrument() : [],
        AppRoutingModule,
        BrowserAnimationsModule,
        MatDatepickerModule,
        MatInputModule,
        StoreModule.forRoot(reducers, {
            metaReducers,
            runtimeChecks: {
                strictStateImmutability: false,
                strictActionImmutability: false
            }
        }),
    ],
    providers: [ConstsHelper, DeviceDetectorService],
    bootstrap: [AppComponent],
})
export class AppModule {}
